module.exports = __webpack_public_path__ + "img/filetype_audio.6e0b1043.png";